var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36813"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4268",
    x: 0.143066,
    y: 0.433594,
    width: 29.5912,
    height: 29.5912,
    rx: 5.70433,
    fill: "#F7F7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 36811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9381 8.70554C14.4853 8.70554 14.1181 9.07267 14.1181 9.52554V20.9342C14.1181 21.3871 14.4853 21.7542 14.9381 21.7542C15.391 21.7542 15.7581 21.3871 15.7581 20.9342V9.52554C15.7581 9.07267 15.391 8.70554 14.9381 8.70554Z",
    fill: "#6F6C90",
    stroke: "#6F6C90",
    strokeWidth: 0.213912,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.23404 14.4106C8.78117 14.4106 8.41404 14.7777 8.41404 15.2306C8.41404 15.6835 8.78116 16.0506 9.23404 16.0506H20.6427C21.0956 16.0506 21.4627 15.6835 21.4627 15.2306C21.4627 14.7777 21.0956 14.4106 20.6427 14.4106H9.23404Z",
    fill: "#6F6C90",
    stroke: "#6F6C90",
    strokeWidth: 0.213912,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionOpen);
export default __webpack_public_path__ + "static/media/accordion_open.8a798d3f749483cee20f4116a932d487.svg";
export { ForwardRef as ReactComponent };